<template>
    <div>
        <GChart 
            type="PieChart"
            :data="data"
            :options="options"
        />
    </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
    name: 'BarGraph',
    components: {
        GChart
    },
    props: {
        data: {
            type: Array
        },
        options: {
            type: Object
        }
    }
}
</script>

<style scoped>
</style>

<style>
.google-visualization-tooltip {
    pointer-events: none;
}
</style>